import React from 'react';
import { FaCreditCard } from 'react-icons/fa';
import { FaCcVisa, FaCcMastercard, FaCcAmex, FaCcDiscover } from 'react-icons/fa6';

export default function CardBrandIcon({ brand, size = 20 }) {
  const color = '#FFFFFF';

  if (!brand) return <FaCreditCard size={size} color={color} />;

  switch (brand.toLowerCase()) {
    case 'visa':
      return <FaCcVisa size={size} color={color} />;
    case 'master':
    case 'mastercard':
      return <FaCcMastercard size={size} color={color} />;
    case 'amex':
      return <FaCcAmex size={size} color={color} />;
    case 'discover':
      return <FaCcDiscover size={size} color={color} />;
    default:
      return <FaCreditCard size={size} color={color} />;
  }
}
